<template>
  <div class="real-success">
    <h6>企业实名认证成功</h6>
    <div class="content">
      <div class="icon">
        <i class="iconfont icon-icon-feiloukong"></i>
      </div>
      <p>企业实名认证成功!</p>
      <div class="btns" v-if="!$route.query.from">
        <el-button type="primary" @click="$router.push('/')" >进入控制台</el-button>
        <el-button @click="$router.push('/cost-center/my-order')">查看我的订单</el-button>
      </div>
      <div v-else class="btns">
        <el-button @click="$router.push({name:'agreement-repository'})">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.real-success {
  padding-top: 40px;
  > h6 {
    width: 1040px;
    margin: 0 auto;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181a;
    margin-bottom: 20px;
  }
  > .content {
    width: 1040px;
    margin: 0 auto;
    background: #ffffff;
    padding-top: 108px;
    padding-bottom: 201px;
    .icon {
      margin: 0 auto 20px;
      width: 40px;
      height: 40px;
      background-color: #0bb976;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 60px;
        color: #e6f8f1;
      }
    }
    > p {
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #16181a;
      letter-spacing: 0;
      text-align: center;
      margin: 16px 0 36px 0;
      height: 16px;
      line-height: 16px;
    }
    .btns {
      margin-top: 60px;
      text-align: center;
      button {
        width: 200px;
        height: 40px;
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
      }
      ::v-deep .el-button:last-child {
        span {
          color: #16181a;
        }
      }
    }
  }
}
</style>
